module.exports = __webpack_public_path__ + "img/plane.f277952f.png";